import { render, staticRenderFns } from "./myIndex.vue?vue&type=template&id=54e78a40&scoped=true&"
import script from "./myIndex.vue?vue&type=script&lang=js&"
export * from "./myIndex.vue?vue&type=script&lang=js&"
import style0 from "./myIndex.vue?vue&type=style&index=0&id=54e78a40&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e78a40",
  null
  
)

export default component.exports